import React, { FC } from 'react';
import './style.scss';

const Paid: FC = () => {
    return (
        <div className="switch-cards">
            <div className="top">
                <div className="titles">
                    <div className="header">Paid Users</div>
                    <div className="detail">4533</div>
                </div>
            </div>
        </div>
    )
}

export default Paid;
